(function(){
  if(window.__nzcUpDelegated) return; window.__nzcUpDelegated = true;
  var stripping = false;
  function refreshCart(){
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true,
        detail: { resource: null, sourceId: 'nzc-gift-upsell', data: { source: 'nzc-gift-upsell' } } }));
    } catch(e) { window.location.reload(); }
  }
  function post(url, body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ if(!r.ok) throw 0; return r.json().catch(function(){ return {}; }); });
  }
  // Discounts can't see selling-plan lines. Normalize: strip plans from tallow lines
  // so the gift engine always works, regardless of how the line was added.
  function stripTallowPlans(){
    if(stripping) return Promise.resolve(false);
    stripping = true;
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var targets = (cart.items||[]).filter(function(it){
        return it.handle === 'manuka-honey-tallow-balm' && it.selling_plan_allocation; });
      var chain = Promise.resolve();
      targets.forEach(function(it){
        chain = chain.then(function(){ return post('/cart/change.js', { id: it.key, quantity: it.quantity, selling_plan: null }); });
      });
      return chain.then(function(){ stripping = false; return targets.length > 0; });
    }).catch(function(){ stripping = false; return false; });
  }
  function normalizeAndMaybeRefresh(){
    stripTallowPlans().then(function(changed){ if(changed) refreshCart(); });
  }
  // run on load + whenever the cart changes (covers STOQ's own widget adds)
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', normalizeAndMaybeRefresh); }
  else { normalizeAndMaybeRefresh(); }
  var debounce;
  document.addEventListener('cart:update', function(ev){
    if(ev && ev.detail && ev.detail.sourceId === 'nzc-gift-upsell') return; // our own refresh; avoid loops
    clearTimeout(debounce); debounce = setTimeout(normalizeAndMaybeRefresh, 400);
  });
  document.addEventListener('click', function(ev){
    var b = ev.target && ev.target.closest ? ev.target.closest('.nzc-up') : null;
    if(!b) return;
    ev.preventDefault(); ev.stopPropagation();
    var box = b.closest('.nzc-gift-box'); if(!box) return;
    var TEN = box.getAttribute('data-ten'), TAL = box.getAttribute('data-tal');
    var action = b.getAttribute('data-action') || 'add';
    b.style.opacity='.6'; b.disabled=true;
    function fail(){ b.style.opacity='1'; b.disabled=false; }
    if(action === 'add'){
      var items; try{ items=JSON.parse(b.getAttribute('data-items')); }catch(e){ return fail(); }
      post('/cart/add.js',{items:items}).then(stripTallowPlans).then(refreshCart).catch(fail);
    } else if(action === 'remove10'){
      var u={updates:{}}; u.updates[TEN]=0;
      post('/cart/update.js',u).then(refreshCart).catch(fail);
    } else if(action === 'swap'){
      post('/cart/add.js',{items:[{id:parseInt(TAL,10),quantity:1}]})
        .then(stripTallowPlans)
        .then(function(){ var u={updates:{}}; u.updates[TEN]=0; return post('/cart/update.js',u); })
        .then(refreshCart).catch(fail);
    }
  }, true);
})();